import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  Tooltip,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import { API_DELETE_MAIN_LAUNDRY } from "api/main-laundry-management";
import EditLaundry from "views/admin/mainlaundryManagement/EditLaundry";
import ViewLaundry from "views/admin/mainlaundryManagement/ViewLaundry/ViewLaundry";
import { API_LIST_ROLE } from "api/role-management";
import { API_DELETE_ROLE } from "api/role-management";
import EditRole from "views/admin/roleManagement/EditRole";
import ViewRole from "views/admin/roleManagement/ViewRole/ViewRole";
import { API_LIST_CATAGORY } from "api/catagory-managemnt";
import { API_DELETE_CATAGORY } from "api/catagory-managemnt";
import EditCatagory from "views/admin/catagorymanagemnt/EditCatagory";
import ViewCatagory from "views/admin/catagorymanagemnt/ViewCatagory/ViewCatagory";
import { API_LIST_SERVICE } from "api/service-managemnt";
import ViewService from "views/admin/ServicesManagemnt/ViewService/ViewService";
import EditService from "views/admin/ServicesManagemnt/EditService";
import { API_DELETE_SERVICE } from "api/service-managemnt";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_DELETE_ITEM_SERVICE } from "api/item-services-managemnt";
import { API_LIST_ITEM_SERVICE } from "api/item-services-managemnt";
import EditItem from "views/admin/itemManagement/EditItem";
import ViewItem from "views/admin/itemManagement/ViewItem/ViewItem";
import { API_LIST_ITEM } from "api/item-management";
import { API_DELETE_ITEM } from "api/item-management";
import { CONSTANTS } from "config/constant";
const { Column } = Table;

const { TextArea } = Input;
const Items = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_ITEM(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_items }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/items/edit/${record._id}`, {
      state: { data: record },
    });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/items/${record._id}`, {
      state: { data: record },
    });
  };

  const handleDelete = async (id) => {
    try {
      let q = await API_DELETE_ITEM(id);
      message.success(q?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting store:", error);
      message.error("Failed to delete store");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };
  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  return (
    <div>
      <div className=" mb-4 flex justify-between">
        <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        />

        <Link
          to={"/admin/items/create-item"} className="linear p-[4px 11px] flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200">
          + {t("Create Item")}
        </Link>
      </div>
      <Table
        dataSource={data?.items}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id} // Assuming each record has a unique id
        rowClassName={getRowClassName} // Apply alternating row colors
        scroll={{ x: true }}
      >

        <Column
          title={t("Image")}
          dataIndex="images"
          key="images"
          render={(text, record) => (
            <span>
              {
                <img
                  src={CONSTANTS?.IMG_DIRECTORY + record?.images?.[0]?.file_url}
                  style={{
                    width: "4rem",
                    height: "4rem",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              }
            </span>
          )}
        />

        <Column title={t("Item Name")} dataIndex="name" key="name" />
        <Column
          title={t("Services Price")}
          dataIndex="name"
          key="name"
          render={(text, record) => {
            const totalServicePrice = record?.item_service?.reduce(
              (acc, service) => acc + (Number(service?.price) || 0),
              0
            );
            return totalServicePrice;
          }}
          // render={(text, record) => record?.item_service?.[0]?.price}
        />
        <Column
          title={t("Category Name")}
          dataIndex="name"
          key="name"
          render={(text, record) => record?.category?.title}
        />

        {/* render={(text, record) => (
            <Tooltip>
              {record?.location?.address?.length > 20 ? `${record?.location?.address?.substring(0, 20)}...` : record?.location.address}
            </Tooltip>
          )} */}
        <Column
          title={t("Item Description")}
          dataIndex="description"
          key="description"
          render={(text) => (
            <Tooltip title={text}>
              {text.length > 50 ? `${text.substring(0, 50)}...` : text}
            </Tooltip>
          )}
          width={"9rem"}
        />

        <Column
          title={t("Actions")}
          key="actions"
          render={(text, record) => (
            <div>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              ></Button>
              <Popconfirm
                title={t("Are you sure to delete this Item ?")}
                onConfirm={() => handleDelete(record?._id)}
                okText={t("Yes")}
                cancelText={t("No")}
              >
                <Button
                  type="danger"
                  icon={<DeleteOutlined />}
                  style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                ></Button>{" "}
              </Popconfirm>
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
            </div>
          )}
        />
      </Table>

      {/* Edit Store Modal */}
      <Modal
        key={selectedStore?._id}
        title={t("Edit Service")}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "65rem" }}
      >
        <EditItem dataItem={selectedStore} />
      </Modal>

      {/* View Store Modal */}
      <Modal
        key={selectedStore?._id}
        title={t("View Service")}
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "60rem" }}
      >
        <ViewItem dataItem={selectedStore} />
      </Modal>
    </div>
  );
};

export default Items;
